export default "__VITE_ASSET__Bm0Ef8Ul__"